exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OutlinesPanel .bookmark-outline-single-container{margin-top:6px;margin-bottom:6px}.OutlinesPanel .bookmark-outline-row{padding-top:6px}.OutlinesPanel .msg-no-bookmark-outline{margin-top:6px}", ""]);

// exports
